<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <div class="search-area">
            <CRow>
                <CCol sm="5" class="pr-1">
                    <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="Tanggal Mulai" v-model="tanggalMulai" class="form-control"/>
                </CCol>
                <CCol sm="5" class="pr-1 pl-1">
                    <input type="text" onfocus="(this.type='date')" onblur="(this.type='text')" placeholder="Tanggal Selesai" v-model="tanggalSelesai" class="form-control"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="6"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-4" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-4 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" :data="datas" :errors="errorMessage"></Tables>
    </div>
    <div v-else class="area-edit">
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div style="padding-top: 12px;padding-left: 20px;padding-right: 20px;padding-bottom: 6px !important;background-color: white;">
            <CRow>
                <CCol sm="2">
                    <span>Nama Kloter</span>
                </CCol>
                <CCol sm="10">
                    : <span class="font-weight-bold">Kloter {{namaKloter}}</span>
                </CCol>
            </CRow>
            <CRow class="mt-1">
                <CCol sm="2">
                    <span>Tanggal</span>
                </CCol>
                <CCol sm="10">
                    : {{separatorTanggal(tanggalMulaiKloter)}} - {{separatorTanggal(tanggalSelesaiKloter)}}
                </CCol>
            </CRow>
            <CRow class="mt-1">
                <CCol sm="2">
                    <span>Total Tagihan Kloter</span>
                </CCol>
                <CCol sm="10">
                    : {{separatorRupiah(tagihanKloter)}}
                </CCol>
            </CRow>
            <CRow class="mt-1">
                <CCol sm="2">
                    <span>Status Kloter</span>
                </CCol>
                <CCol sm="10">
                    : <span class="font-weight-bold" :style="{ color : dataStatusColor }">{{dataStatusKeterangan}}</span>
                </CCol>
            </CRow>
            <CRow class="mt-1" v-if="dataStatusKloter != 'W'">
                <CCol sm="2" v-if="dataStatusKloter == 'A'">
                    <span>Approve By</span>
                </CCol>
                <CCol sm="2" v-if="dataStatusKloter == 'R'">
                    <span>Reject By</span>
                </CCol>
                <CCol sm="10">
                    : {{dataApproveBy}}
                </CCol>
            </CRow>
            <CRow class="mt-1" v-if="dataStatusKloter != 'W'">
                <CCol sm="2" v-if="dataStatusKloter == 'A'">
                    <span>Approve Date</span>
                </CCol>
                <CCol sm="2" v-if="dataStatusKloter == 'R'">
                    <span>Reject Date</span>
                </CCol>
                <CCol sm="10">
                    : {{dataApproveDate}}
                </CCol>
            </CRow>
            <CRow class="mt-1" v-if="dataStatusKloter == 'R'">
                <CCol sm="2">
                    <span>Keterangan</span>
                </CCol>
                <CCol sm="10">
                    : {{dataKeteranganKloter}}
                </CCol>
            </CRow>
        </div>
        <div class="search-area">
            <CRow>
                <CCol sm="5" class="pr-1">
                    <div class="autocomplete">
                        <input type="text"
                                class="form-control"
                                @click="toggleVisiblePegawai()"
                                @blur="toggleCloseVisiblePegawai()"
                                v-model="queryPegawai"
                                v-text="selectedItemPegawai ? selectedItemPegawai['text'] : ''"
                                @keydown.up="upPegawai"
                                @keydown.down="downPegawai"
                                @keydown.enter="selectItemPegawai"
                                placeholder="Pilih Pegawai"
                        >
                        <div class="popovers" v-show="visiblePegawai">
                            <div class="options" v-if="matchesPegawai.length != 0 && queryPegawai.length != 0" ref="optionsList">
                                <ul>
                                <li v-for="(match, index) in matchesPegawai"
                                    :key="index"
                                    :class="{ 'selected': (selectedPegawai == index)}"
                                    @click="itemClickedPegawai(index)"
                                    v-text="match['text']"></li>
                                </ul>
                            </div>
                            <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length != 0">
                                Data Tidak Ditemukan
                            </div>
                            <div class="options" v-if="matchesPegawai.length == 0 && queryPegawai.length == 0">
                                Start Typing...
                            </div>
                        </div>
                    </div>
                </CCol>
                <CCol sm="5" class="pr-1 pl-1">
                    <model-select style="background-color:rgba(249, 250, 252, 1)" :options="filterDataStatus" class="form-control" v-model="status" placeholder="Status"></model-select>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findDataDetail()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="6"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="pageDetail == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePageDetail('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="pageDetail == totalPageDetail" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePageDetail('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePageDetail(pageDetail)" v-if="totalPageDetail != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="pageDetail" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="pageDetail" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPageDetail}} - {{lastPageDetail}}</span> of {{totalRowDetail}}</span>
                    <img class="mt-1 mr-4" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-4 mt-1" v-if="datas.length != 0" @click="getDownload()" style="float:right;cursor:pointer" :src="downloadIcon" title="export to excel"  width="20px" height="20px"/>
                    <!-- <img class="mr-4 mt-1" @click="reloadDetail()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/> -->
                </CCol>
            </CRow>
        </div>
        <div class="tableFixHead sticky2">
            <table>
                <thead class="text-center">
                    <tr>
                        <th class="text-left" style="width:100px;max-width:100px">Nama Pegawai</th>
                        <th class="text-left" style="width:75px;max-width:75px">Jabatan</th>
                        <th class="text-left" style="width:50px;max-width:50px">Tanggal</th>
                        <th class="text-left" style="width:75px;max-width:75px">Total Pengajuan</th>
                        <th class="text-left" style="width:75px;max-width:75px;">Total Dibayarkan</th>
                        <th class="text-left" style="width:75px;max-width:75px">Status</th>
                        <th class="text-left" style="width:25px;max-width:25px">File</th>
                        <th v-if="dataStatusKloter == 'A'" class="text-left" style="width:75px;max-width:75px">Action</th>
                    </tr>
                    <tr>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="content-sticky">
            <CRow>
                <CCol sm="12">
                    <div class="tableFixHead">
                        <table>
                            <tbody v-if="datasDetail.length == 0">
                                <tr>
                                    <td class="text-center" colspan="5">
                                        {{errorMessageDetail}}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody>
                                <tr v-for="(body, id) in datasDetail" :key="id">
                                    <td style="width:100px;max-width:100px">{{body.namaPegawai}}</td>
                                    <td style="width:75px;max-width:75px" :title="body.jabatan">{{body.jabatan}}</td>
                                    <td style="width:50px;max-width:50px;padding-left:10px;padding-right:10px;">{{separatorTanggal(body.createdDate)}}</td>
                                    <td style="width:75px;max-width:75px"><span style="float:right">{{separatorRupiah(body.totalPengajuan)}}</span></td>
                                    <td style="width:75px;max-width:75px"><span style="float:right">{{separatorRupiah(body.totalApprove)}}</span></td>
                                    <td style="width:75px;max-width:75px" :title="body.keteranganStatus">
                                        <span class="font-weight-bold" :style="{ color : body['color'] }">{{body.keteranganStatus}}</span>
                                    </td>
                                    <td style="width:25px;max-width:25px">
                                        <CRow>
                                            <CCol sm="6" v-for="(bodys, ids) in body.daftarUrlFile" :key="ids">
                                                <img :src="downloadIcon" @click="direct(bodys)" width="20px" height="20px" style="cursor:pointer"/>
                                            </CCol>
                                        </CRow>
                                    </td>
                                    <td v-if="dataStatusKloter == 'A'" style="width:75px;max-width:75px">
                                        <div class="text-center">
                                            <CButton @click="goDetail(id)" v-if="body.status == 'A' || body.status == 'P'" class="btn btn-edit">Bayar</CButton>
                                            <CButton @click="goDetail(id)" v-else class="btn btn-edit">View</CButton>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </CCol>
            </CRow>
        </div>
    </div>
    <CModal
        size="xl"
        :centered="true"
        color="white"
        :show.sync="modalDetail"
        :closeOnBackdrop="false"
        >
        <template #header-wrapper>
            <div class="headers-modal">
                <CRow>
                    <CCol sm="10">
                        <div>Detail Pembayaran Pengajuan Reimburse</div>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img :src="closeIcon" @click="modalDetail = false" style="cursor:pointer" width="20px" height="20px"/>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #body-wrapper>
            <div style="padding-right:20px;padding-left:20px">
                <CRow>
                    <CCol sm="3">
                        Nama
                    </CCol>
                    <CCol sm="9">
                        : <span class="font-weight-bold">{{dataNama}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        Jabatan
                    </CCol>
                    <CCol sm="9">
                        : <span>{{dataJabatan}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        Tanggal Pengajuan
                    </CCol>
                    <CCol sm="9">
                        : {{separatorTanggal(dataTanggalPengajuan)}}
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        Nomor Kartu
                    </CCol>
                    <CCol sm="9">
                        : {{dataNoKartu}}
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        Nomor Reimburse
                    </CCol>
                    <CCol sm="9">
                        : {{dataNoReimburse}}
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        Total Pengajuan
                    </CCol>
                    <CCol sm="9">
                        : <span class="font-weight-bold">{{separatorRupiah(dataTotalPengajuan)}}</span>
                    </CCol>
                </CRow>
                <CRow v-if="dataStatus != 'A'" class="mt-2">
                    <CCol sm="3">
                        Total Dibayarkan
                    </CCol>
                    <CCol sm="9">
                        : {{separatorRupiah(dataTotalDibayarkan)}}
                    </CCol>
                </CRow>
                <CRow v-if="dataStatus != 'A'" class="mt-2">
                    <CCol sm="3">
                        Tanggal Dibayarkan
                    </CCol>
                    <CCol sm="9">
                        : {{separatorTanggal(dataTanggalDibayarkan)}}
                    </CCol>
                </CRow>
                <CRow v-if="dataStatus != 'A'" class="mt-2">
                    <CCol sm="3">
                        Total Tidak Dibayarkan
                    </CCol>
                    <CCol sm="9">
                        : {{separatorRupiah(dataTotalTidakDibayarkan)}}
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        Status
                    </CCol>
                    <CCol sm="9">
                        : <span class="font-weight-bold" :style="{ color : dataColor }">{{dataKeteranganStatus}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-2">
                    <CCol sm="3">
                        Nama Kloter
                    </CCol>
                    <CCol sm="9">
                        : <span class="font-weight-bold">Kloter {{namaKloter}}</span>
                    </CCol>
                </CRow>
                <CRow v-if="dataStatus != 'A'" class="mt-2">
                    <CCol sm="3">
                        Riwayat Reimburse
                    </CCol>
                    <CCol sm="9">
                        <ul class="StepProgress">
                            <li class="StepProgress-item" v-for="(item, index) in dataKeterangan" :key="'track'+index" :class="[item.selesai != 'Y' ? 'is-done' : '']">
                                    <div>
                                    <span :style="{ color : item.color }" class="font-weight-bold">{{item.action}}</span>
                                </div>
                                <div>oleh {{item.namaApproval}} at {{item.tanggal}}</div>
                                <div>{{item.keterangan}}</div>
                            </li>
                        </ul>
                    </CCol>
                </CRow>
                <CRow class="mt-3">
                    <CCol sm="12">
                        <span class="font-weight-bold">Daftar Peserta</span>
                        <table>
                            <thead>
                                <tr>
                                    <th class="width:25%">Nama</th>
                                    <th class="width:45%">Diagnosa</th>
                                    <th class="width:15%">Tgl Kwitansi</th>
                                    <th class="width:15%">Biaya</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(body, id) in dataPeserta" :key="id">
                                    <td class="width:25%">{{body.nama}}</td>
                                    <td class="width:45%">{{body.diagnosa}}</td>
                                    <td class="width:15%">{{separatorTanggal(body.tanggalKwitansi)}}</td>
                                    <td class="width:15%"><span style="float:right">{{separatorRupiah(body.biaya)}}</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </CCol>
                </CRow>
            </div>
            <CRow class="mt-4" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                <CCol class="text-right" sm="12">
                    <CButton v-if="dataStatus == 'A' || dataStatus == 'P'" @click="modalApprove = true" style="float:right" class="btn-edit-submit ml-2">Pay</CButton>
                    <CButton v-if="dataStatus == 'A' || dataStatus == 'P'" @click="modalPending = true" style="float:right" class="btn-edit-pending ml-2">Confirmation</CButton>
                    <CButton v-if="dataStatus == 'A' || dataStatus == 'P'" @click="modalReject = true" style="float:right" class="btn-edit-delete ml-2">Reject</CButton>
                    <CButton @click="modalDetail = false" style="float:right" class="btn-cancel">Back</CButton>
                </CCol>
            </CRow>
        </template>
        <template #footer-wrapper><span></span></template>
    </CModal>
    <CModal
        size="md"
        :centered="true"
        color="white"
        :show.sync="modalApprove"
        :closeOnBackdrop="false"
        >
        <template #header-wrapper>
            <div class="headers-modal">
                <CRow>
                    <CCol sm="10">
                        <div>Pembayaran Reimburse</div>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img :src="closeIcon" @click="modalApprove = false,inputKeterangan = '', inputNominal = ''" style="cursor:pointer" width="20px" height="20px"/>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #body-wrapper>
            <div style="padding-right:20px;padding-left:20px">
                <CRow>
                    <CCol sm="5">
                        Total Pengajuan
                    </CCol>
                    <CCol sm="7">
                        : <span class="font-weight-bold">{{separatorRupiah(dataTotalPengajuan)}}</span>
                    </CCol>
                </CRow>
                <CRow class="mt-3">
                    <CCol sm="12">
                        <label>Masukan nominal yang ingin dibayarkan</label>
                        <input
                            onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                            v-model="inputNominal"
                            @input="rupiahModeUangSaku()"
                            placeholder="Nominal"
                            class="form-control" />
                    </CCol>
                </CRow>
                <CRow class="mt-3">
                    <CCol sm="12">
                        <label>Tanggal Bayar</label>
                        <input
                            v-model="tanggalBayar"
                            placeholder="Nominal"
                            type="date"
                            class="form-control" />
                    </CCol>
                </CRow>
                <CRow class="mt-3">
                    <CCol sm="12">
                        <label>Masukan Keterangan</label>
                        <textarea
                            v-model="inputKeterangan"
                            placeholder="Keterangan"
                            class="form-control"/>
                    </CCol>
                </CRow>
                <CRow class="mt-4" v-if="errFlag == true">
                    <CCol sm="12">
                        <span v-if="err == '1'" class="text-danger" style="font-size:12px">*Nominal yang dimasukan melebihi nominal yang di ajukan</span>
                        <span v-if="err == '2'" class="text-danger" style="font-size:12px">*Nominal harus diisi</span>
                        <span v-if="err == '3'" class="text-danger" style="font-size:12px">*Keterangan harus diisi</span>
                        <span v-if="err == '4'" class="text-danger" style="font-size:12px">*Tanggal Bayar harus diisi</span>
                    </CCol>
                </CRow>
            </div>
            <CRow class="mt-4" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                <CCol sm="6">
                    <CButton style="width:100%!important" @click="modalApprove = false,inputKeterangan = '', inputNominal = ''" class="btn-cancel">Back</CButton>
                </CCol>
                <CCol sm="6">
                    <CButton style="width:100%!important" @click="goSave('B')" class="btn-edit-submit">Pay</CButton>
                </CCol>
            </CRow>
        </template>
        <template #footer-wrapper><span></span></template>
    </CModal>

    <CModal
        size="md"
        :centered="true"
        color="white"
        :show.sync="modalPending"
        :closeOnBackdrop="false"
        >
        <template #header-wrapper>
            <div class="headers-modal">
                <CRow>
                    <CCol sm="10">
                        <div>Konfirmasi Reimburse</div>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img :src="closeIcon" @click="modalPending = false,inputKeterangan = ''" style="cursor:pointer" width="20px" height="20px"/>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #body-wrapper>
            <div style="padding-right:20px;padding-left:20px">
                <CRow>
                    <CCol sm="12">
                        <label>Masukan Keterangan</label>
                        <textarea v-model="inputKeterangan" placeholder="Keterangan" class="form-control"/>
                    </CCol>
                </CRow>
                <CRow class="mt-4" v-if="errFlag == true">
                    <CCol sm="12">
                        <span v-if="err == '3'" class="text-danger" style="font-size:12px">*Keterangan harus diisi</span>
                    </CCol>
                </CRow>
            </div>
            <CRow class="mt-4" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                <CCol sm="6">
                    <CButton style="width:100%!important" @click="modalPending = false,inputKeterangan = ''" class="btn-cancel">Back</CButton>
                </CCol>
                <CCol sm="6">
                    <CButton style="width:100%!important" @click="goSave('P')" class="btn-edit-pending">Confirmation</CButton>
                </CCol>
            </CRow>
        </template>
        <template #footer-wrapper><span></span></template>
    </CModal>

    <CModal
        size="md"
        :centered="true"
        color="red"
        :show.sync="modalReject"
        :closeOnBackdrop="false"
        >
        <template #header-wrapper>
            <div class="headers-modal">
                <CRow>
                    <CCol sm="10">
                        <div>Reject Reimburse</div>
                    </CCol>
                    <CCol sm="2" class="text-right">
                        <img :src="closeIcon" @click="modalReject = false,inputKeterangan = ''" style="cursor:pointer" width="20px" height="20px"/>
                    </CCol>
                </CRow>
            </div>
        </template>
        <template #body-wrapper>
            <div style="padding-right:20px;padding-left:20px">
                <CRow>
                    <CCol sm="12">
                        <label>Masukan Keterangan</label>
                        <textarea v-model="inputKeterangan" placeholder="Keterangan" class="form-control"/>
                    </CCol>
                </CRow>
                <CRow class="mt-4" v-if="errFlag == true">
                    <CCol sm="12">
                        <span v-if="err == '3'" class="text-danger" style="font-size:12px">*Keterangan harus diisi</span>
                    </CCol>
                </CRow>
            </div>
            <CRow class="mt-4" style="padding-bottom:40px;padding-left:20px;padding-right:20px">
                <CCol sm="6">
                    <CButton style="width:100%!important" @click="modalReject = false,inputKeterangan = ''" class="btn-cancel">Back</CButton>
                </CCol>
                <CCol sm="6">
                    <CButton style="width:100%!important" @click="goSave('R')" class="btn-edit-delete">Reject</CButton>
                </CCol>
            </CRow>
        </template>
        <template #footer-wrapper><span></span></template>
    </CModal>
</div>
</template>

<script>
import Tables from '../../../component/tableReimbursDetail'
import { ModelSelect } from 'vue-search-select'
import {DataApi} from "../../../service/DataApi";
export default {
    components: {
        Tables,
        ModelSelect
    },
    data() {
        return {
            // data search pegawai
            dataPegawai: [],
            titlePegawai:"Pilih Pegawai",
            selectedItemPegawai: null,
            selectedPegawai: 0,
            queryPegawai: '',
            visiblePegawai: false,

            filterDataStatus: [],
            status: {
                value: '',
                text: ''
            },

            success: true,
            // datas
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            closeIcon: require('../../../assets/menu/icon_close.svg'),
            downloadIcon: require('../../../assets/menu/icon_download_excel.svg'),
            classReload: 'reloadOff',
            datas: [],
            datasDetail: [],
            goArea: true,
            loading: false,
            loadingReject: false,
            alertMess: '',
            currentAlertCounter: 0,

            // data model
            dataNama: '',
            dataJabatan: '',
            dataTanggalPengajuan: '',
            dataTanggalDibayarkan: '',
            dataNoKartu: '',
            dataNoReimburse: '',
            dataTotalPengajuan: '',
            dataTotalDibayarkan: '',
            dataTotalTidakDibayarkan: '',
            dataUnix: '',
            dataKeterangan: '',
            dataStatus: '',
            dataKeteranganStatus: '',
            dataColor: '',
            dataPeserta: [],
            inputNominal: '',
            sendNominal: '',
            inputKeterangan: '',
            dataStatusKloter: '',
            dataKeteranganKloter: '',
            dataStatusKeterangan: '',
            dataStatusColor: '',
            dataApproveBy: '',
            dataApproveDate: '',

            // paging
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            modalDetail: false,
            modalApprove: false,
            modalPending: false,
            modalReject: false,
            pageDetail: 1,
            sizeDetail: 20,
            totalRowDetail: 0,
            totalPageDetail: 1,
            firstPageDetail: 0,
            lastPageDetail: 0,
            namaKloter: '',
            tanggalMulaiKloter: '',
            tanggalSelesaiKloter: '',
            tagihanKloter: '',

            // filter
            tanggalMulai: '',
            tanggalSelesai: '',
            tanggalBayar: '',

            // error
            errorMessage: '',
            errorMessageDetail: '',
            errFlag: false,
            err: '',
            flagSearch: false,
            flagSearchDetail: false
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        pageDetail() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        tanggalMulai() {
            this.flagSearch = true
            this.queryPegawai = ''
            this.status.value = ''
        },
        tanggalSelesai() {
            this.flagSearch = true
            this.queryPegawai = ''
            this.status.value = ''
        },


        queryPegawai() {
            this.flagSearchDetail = true
            this.getDataPegawai()
        },
        status() {
            this.flagSearchDetail = true
        },
        goArea() {
            this.status.value = ''
            this.status.text = ''
            this.queryPegawai = ''
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        inputNominal() {
            if(this.inputNominal != '') {
                let nom = this.inputNominal.replace("Rp. ", '')
                let nom1 = ''
                var i
                for(i=0;i<nom.length;i++) {
                    if(nom[i] == '.') {
                        //
                    } else {
                        nom1 += nom[i]
                    }
                }
            }
        },
        modalApprove() {
            if(this.modalApprove == true) {
                this.errFlag = false
                this.err = ''
                this.inputKeterangan = ''
                this.inputNominal = ''
                this.tanggalBayar = ''
            }
        },
        modalPending() {
            if(this.modalPending == true) {
                this.errFlag = false
                this.inputKeterangan = ''
                this.err = ''
            }
        },
        modalReject() {
            if(this.modalReject == true) {
                this.errFlag = false
                this.inputKeterangan = ''
                this.err = ''
            }
        }
    },
    computed: {
        matchesPegawai() {
            if (this.queryPegawai == '') {
                return [];
            }
            return this.dataPegawai.filter((item) => item['text'].toLowerCase().includes(this.queryPegawai.toLowerCase()))
        },
    },
    methods: {
        /**
         * SEARCH PEGAWAI
         */
        getDataPegawai() {
            let payload = {
                bidang: '',
                jabatan: '',
                limit: 10,
                nama: this.queryPegawai,
                pageIn: 1,
                pegawaiId: '',
                tipePegawai: ''
            }
            DataApi.post("pegawai/get", payload)
            .then(res => {
                this.dataPegawai = []
                let response = res.data
                let tempData = response.data.data
                var i = 0;
                for(i=0;i<tempData.length;i++) {
                    let onPush = {
                        value: tempData[i].nik,
                        text: tempData[i].nama + ' - ' + tempData[i].nik
                    }
                    this.dataPegawai.push(onPush)
                }
            })
        },
        toggleVisiblePegawai() {
            this.visiblePegawai = true;
        },
        hidePegawai() {
            this.visiblePegawai = false;
        },
        toggleCloseVisiblePegawai() {
            setTimeout(this.hidePegawai, 1000);
        },
        itemClickedPegawai(index) {
            this.selectedPegawai = index;
            this.selectItemPegawai();
        },
        selectItemPegawai() {
            if (!this.matchesPegawai.length) {
            return;
            }
            this.selectedItemPegawai = this.matchesPegawai[this.selectedPegawai];
            this.visiblePegawai = false;
            this.queryPegawai = this.selectedItemPegawai.text
            if (this.shouldReset) {
            this.queryPegawai = '';
            this.selectedPegawai = 0;
            }
        },
        upPegawai() {
            if (this.selectedPegawai == 0) {
            return;
            }
            this.selectedPegawai -= 1;
            this.scrollToItemPegawai();
        },
        downPegawai() {
            if (this.selectedPegawai >= this.matchesPegawai.length - 1) {
            return;
            }
            this.selectedPegawai += 1;
            this.scrollToItemPegawai();
        },
        scrollToItemPegawai() {
            this.$refs.optionsList.scrollTop = this.selectedPegawai * this.itemHeight;
        },

        getDataStatus() {
            this.filterDataStatus = [{ value: '', text: 'Semua' }]
            let stat = ''
            if(this.dataStatusKloter == 'W') {
                stat = 'A'
            } else if(this.dataStatusKloter == 'R') {
                stat = 'C'
            } else {
                stat = 'B'
            }
            let payload = {
                aktif: "1",
                description: "",
                fieldReason: "",
                isApproval: "",
                isPegawaiAtasan: "",
                limit: 9999,
                nama: "",
                modul: 2,
                tipe: stat,
                pageIn: 1
            }
            DataApi.post("overtime/status/approval/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    let datas = response.data.data
                    var i
                    for(i=0;i<datas.length;i++) {
                        let onPush = {
                            value: datas[i].unix,
                            text: datas[i].nama
                        }
                        this.filterDataStatus.push(onPush)
                    }
                }
            })
        },

        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.nama.toLowerCase() < b.nama.toLowerCase()) {
                        return -1
                    }
                    if (a.nama.toLowerCase() > b.nama.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.alamat.toLowerCase() < b.alamat.toLowerCase()) {
                        return -1
                    }
                    if (a.alamat.toLowerCase() > b.alamat.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 2) {
                function compare(a,b) {
                    if (a.kota.toLowerCase() < b.kota.toLowerCase()) {
                        return -1
                    }
                    if (a.kota.toLowerCase() > b.kota.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 3) {
                function compare(a,b) {
                    if (a.provinsi.toLowerCase() < b.provinsi.toLowerCase()) {
                        return -1
                    }
                    if (a.provinsi.toLowerCase() > b.provinsi.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 4) {
                function compare(a,b) {
                    if (a.latitude.toLowerCase() < b.latitude.toLowerCase()) {
                        return -1
                    }
                    if (a.latitude.toLowerCase() > b.latitude.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 5) {
                function compare(a,b) {
                    if (a.longitude.toLowerCase() < b.longitude.toLowerCase()) {
                        return -1
                    }
                    if (a.longitude.toLowerCase() > b.longitude.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 6) {
                function compare(a,b) {
                    if (a.radius.toLowerCase() < b.radius.toLowerCase()) {
                        return -1
                    }
                    if (a.radius.toLowerCase() > b.radius.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let payload = {
                limit: this.size,
                pageIn: this.page,
                tanggalMulai: this.tanggalMulai,
                tanggalSelesai: this.tanggalSelesai
            }
            DataApi.post("/reimburse/cloter/lihat/backoffice", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        getDataDetail() {
            if(this.flagSearchDetail == true) {
                this.pageDetail = 1
            }
            this.$store.state.loadingScreen = true
            let payload = {
                kloter: this.kloter,
                limit: this.sizeDetail,
                nama: this.queryPegawai.split(" - ")[0],
                pageIn: this.pageDetail,
                status: this.status.value
            }
            DataApi.post("/reimburse/cloter/detail", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    let resHead = response.data
                    this.dataStatusKloter = resHead.statusKloter
                    this.dataStatusKeterangan = resHead.keteranganStatusKloter
                    this.dataStatusColor = resHead.colorKloter
                    this.namaKloter = resHead.kloter
                    this.tanggalMulaiKloter = resHead.tanggalMulaiKloter
                    this.tanggalSelesaiKloter = resHead.tanggalSelesaiKloter
                    this.tagihanKloter = resHead.totalPengajuanKloter
                    this.dataApproveBy = resHead.approverKloter
                    this.dataApproveDate = resHead.tanggalApproveKloter
                    this.dataKeteranganKloter = resHead.keteranganApproveKloter

                    this.datasDetail = response.data.data
                    this.totalRowDetail = response.data.totalRow
                    this.firstPageDetail = (((this.pageDetail - 1) * this.sizeDetail) + 1 )
                    this.lastPageDetail = (((this.pageDetail - 1) * this.sizeDetail) + this.datasDetail.length )
                    this.totalPageDetail = Math.floor(this.totalRowDetail/this.sizeDetail)
                    let modAr = this.totalRowDetail%this.sizeDetail
                    if(modAr != 0) {
                        this.totalPageDetail = this.totalPageDetail + 1
                    } else {
                        //
                    }
                } else {
                    this.datasDetail = []
                    this.totalRowDetail = 0
                    this.firstPageDetail = 0
                    this.lastPageDetail = 0
                    this.totalPageDetail = 1
                    this.errorMessageDetail = response.message
                }
                this.flagSearchDetail = false
                this.$store.state.loadingScreen = false
                this.getDataStatus()
            })
        },
        goDetail(id) {
            let temp = this.datasDetail[id]

            this.dataNama = temp.namaPegawai,
            this.dataJabatan = temp.jabatan,
            this.dataTanggalPengajuan = temp.createdDate,
            this.dataTanggalDibayarkan = temp.tanggalBayar,
            this.dataNoKartu = temp.noKartuPeserta,
            this.dataNoReimburse = temp.noReimburse,
            this.dataTotalPengajuan = temp.totalPengajuan,
            this.dataTotalDibayarkan = temp.totalApprove,
            this.dataTotalTidakDibayarkan = temp.totalTidakApprove,
            this.dataKeterangan = temp.history,
            this.dataStatus = temp.status,
            this.dataColor = temp.color
            this.dataKeteranganStatus = temp.keteranganStatus
            this.dataPeserta = temp.daftarPeserta
            this.dataUnix = temp.unix

            this.modalDetail = true
        },
        getDownload() {
            if(this.datas.length != 0) {
                let payload = {
                    kloter: this.kloter,
                    limit: this.totalRowDetail,
                    nama: this.queryPegawai,
                    pageIn: 1,
                    status: this.status.value
                }
                DataApi.post("/export/reimburse/cloter/detail", payload , {responseType: 'blob'})
                .then(res => {
                    let response = res.data
                    // let fileName = res.headers["content-disposition"].split("filename=")[1];
                    const url = URL.createObjectURL(new Blob([response], {
                        type: 'application/vnd.ms-excel'
                    }))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute('download', 'Data Reimburse Kloter')
                    document.body.appendChild(link)
                    link.click()
                })
            }
        },
        findData() {
            this.getData()
        },
        findDataDetail() {
            this.getDataDetail()
        },
        reload() {
            this.tanggalMulai = ''
            this.tanggalSelesai = ''
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        movePageDetail(direction) {
            if(direction == 'prev') {
                this.pageDetail = this.pageDetail -  1
            } else {
                this.pageDetail = this.pageDetail +  1
            }
            this.getDataDetail()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        validatePageDetail(page) {
            if(page > this.totalPageDetail) {
                this.pageDetail = this.totalPageDetail
            }
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea, 600);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
            } else {
                this.getData()
                this.goArea = true
                this.pageDetail = 1
            }
        },
        goSave(val) {
            let val1 = false
            let val2 = false
            let val3 = false
            let val4 = false
            

            if(val == 'B') {
                this.sendNominal = ''
                let clear = ''
                if(this.inputNominal == '') {
                    val2 = true
                    this.err = '2'
                } else {
                    val2 = false
                    clear = this.inputNominal.replace("Rp. ", '')
                    var i
                    for(i=0;i<clear.length;i++) {
                        if(clear[i] == '.') {
                            //
                        } else {
                            this.sendNominal += clear[i]
                        }
                    }

                    if(parseInt(this.sendNominal) > parseInt(this.dataTotalPengajuan)) {
                        this.err = '1'
                        val1 = true
                    } else {
                        val1 = false
                    }

                    if(this.inputKeterangan == '') {
                        val3 = true
                        this.err = '3'
                    } else {
                        val3 = false
                    }
                    
                    if(this.tanggalBayar == '') {
                        val4 = true
                        this.err = '4'
                    } else {
                        val4 = false
                    }
                }
            } else {
                this.sendNominal = '0'
                this.inputNominal = '0'
                this.tanggalBayar = ''
                if(this.inputKeterangan == '') {
                    val3 = true
                    this.err = '3'
                }
                val4 = false
            }
            
        
            if(val1 == false && val2 == false && val3 == false && val4 == false) {
                this.err = ''
                this.errFlag = false
                this.modalApprove = false
                this.modalPending = false
                this.modalReject = false
                this.goSubmit(val)
            } else {
                this.errFlag = true
            }
            
        },
        goSubmit(val) {
            let payload = {
                keteranganApprove: this.inputKeterangan,
                status: val,
                totalApprove: this.sendNominal,
                tanggalBayar: this.tanggalBayar,
                unix: this.dataUnix
            }
            DataApi.post("/reimburse/save/backoffice", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getDataDetail()
                this.modalDetail = false
                this.currentAlertCounter = 7
                this.inputNominal = ''
                this.inputKeterangan = ''
                window.scroll({
                    top:0,
                    left: 0,
                    behavior: 'smooth'
                });
            })
        },

        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            this.kloter = generate.kloter
            this.getDataDetail()
            this.moving()
        },
        separatorTanggal(val) {
            let tanggal = val.split("-")[2]
            let bulanTemp = val.split("-")[1]
            let tahun = val.split("-")[0]
            let bulan = ''
            if(bulanTemp == '01' || bulanTemp == '1') {
                bulan = 'Jan'
            } else if(bulanTemp == '02' || bulanTemp == '2') {
                bulan = 'Feb'
            } else if(bulanTemp == '03' || bulanTemp == '3') {
                bulan = 'Mar'
            } else if(bulanTemp == '04' || bulanTemp == '4') {
                bulan = 'Apr'
            } else if(bulanTemp == '05' || bulanTemp == '5') {
                bulan = 'Mei'
            } else if(bulanTemp == '06' || bulanTemp == '6') {
                bulan = 'Jun'
            } else if(bulanTemp == '07' || bulanTemp == '7') {
                bulan = 'Jul'
            } else if(bulanTemp == '08' || bulanTemp == '8') {
                bulan = 'Agu'
            } else if(bulanTemp == '09' || bulanTemp == '9') {
                bulan = 'Sep'
            } else if(bulanTemp == '10') {
                bulan = 'Okt'
            } else if(bulanTemp == '11') {
                bulan = 'Nov'
            } else if(bulanTemp == '12') {
                bulan = 'Des'
            }
            return tanggal + ' ' + bulan + ' ' + tahun
        },
        separatorRupiah(val) {
            let leng = val.length
            let sisa 	= leng % 3
            let rupiah 	= val.substr(0, sisa)
            let ribuan 	= val.substr(sisa).match(/\d{3}/g)
                
            if (ribuan) {
                let separator = sisa ? '.' : ''
                rupiah += separator + ribuan.join('.')
            }
            return 'Rp. ' + rupiah 
        },
        rupiahModeUangSaku() {
            var number_string = this.inputNominal.toString().replace(/[^,\d]/g, '')
            var split           = number_string.split(',')
            var sisa             = split[0].length % 3
            var rupiah             = split[0].substr(0, sisa)
            var ribuan             = split[0].substr(sisa).match(/\d{3}/gi)
            var prefix = "Rp. "
        
            // tambahkan titik jika yang di input sudah menjadi angka satuan ribuan
            if(ribuan){
                var separator = sisa ? '.' : '';
                rupiah += separator + ribuan.join('.');
            }
        
            rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
            let hasil = prefix == undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');
            this.inputNominal = hasil
        },
        submitForm() {
            this.modalApprove = true
        },
        direct(link) {
            window.open(
                link,
                '_blank' // <- This is what makes it open in a new window.
            );
        },

    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataPegawai()
    }
}
</script>
<style scoped>
::v-deep .modal-header {
    border-bottom: none !important;
}
.headers-modal {
    padding-top: 32px;
    padding-bottom: 32px;
    padding-left: 20px;
    padding-right: 20px;
    font-size: 18px;
    font-weight: bold;
    color: rgba(16, 16, 16, 1);
}
.containers {
    background-color: white;
    border-bottom: 1px solid #e5e6e8;
}
.autocomplete {
    width: 100%;
    position: relative;
}
.input {
    cursor: text;
}
.close {
    position: absolute;
    right: 8px;
    top: 10px;
    background: none;
    border: none;
    font-size: 14px;
    color: lightgrey;
    cursor: pointer;
}
.placeholder {
    position: absolute;
    top: 7px;
    left: 16px;
    font-size: 14px;
    color: #d0d0d0;
}
.popovers {
    text-align: center;
    width: 100% !important;
    min-height: 50px;
    border: 1px solid #d8dbe0;
    position: absolute;
    top: 35px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 8px;
    left: 0;
    right: 0;
    background: #fff;
    border-radius: 3px;
    text-align: center;
    z-index: 3;
}
.popovers input {
    right: 8px;
    left: 8px;
    width: 100%;
}
.options {
    max-height: 200px;
    overflow-y: auto;
    margin-top: 5px;
}
.options ul {
    list-style-type: none;
    text-align: left;
    padding-left: 0;
}
.options ul li {
    border-bottom: 1px solid lightgrey;
    padding: 10px;
    cursor: pointer;
    background: white;
}
.options ul li:first-child {
    border-top: 1px solid lightgray;
}
.options ul li:not(.selected):hover {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.options ul li.selected {
    background: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}

.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-edit-delete {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:red;
    color: white;
    font-size: 14px;
}
.btn-edit-pending {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:#636f83;
    color: white;
    font-size: 14px;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
    padding-top: 32px;
}
.select-invalid {
    border: 1px solid #e55353 !important;
}
.select-valid {
    border: 1px solid #2eb85c !important;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.cards-image {
    position: absolute;
    text-align: center;
    font-size: 27px;
    color: rgba(96, 96, 96, 1);
    line-height: 50px;
    border: 1px dotted rgba(221, 221, 221, 1);
    width: 56px !important;
    background-color: rgba(250, 250, 250, 1);
    height: 56px !important;
}
.invalid-feedback {
    margin-top: -16px;
    float: right;
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
div.sticky2 {
    position: -webkit-sticky;
    position: sticky;
    top: 105px;
    background-color: white;
    z-index: 1;
}
.content-sticky {
    background-color: white;
}
.btn-edit {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: white;
    color: black;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
}
.btn-edit:hover {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: rgba(154, 154, 154, 1);
    color: white;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
}
.modal-button-cancel {
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: white;
    color: rgba(16, 16, 16, 1);
}
.modal-button-cancel:hover {
    border: 1px solid rgba(48, 107, 240, 1);
    background-color: whitesmoke;
    color: rgba(16, 16, 16, 1);
}
.StepProgress {
    position: relative;
    padding-left: 45px;
    list-style: none;
}
.StepProgress::before {
    display: inline-block;
    content: '';
    position: absolute;
    top: 5px;
    left: 15px;
    width: 10px;
    height: 80%;
    border-left: 2px solid #CCC;
}
.StepProgress-item {
    position: relative;
    counter-increment: list;
}
.StepProgress-item:not(:last-child) {
    padding-bottom: 20px;
}
.StepProgress-item::before {
    display: inline-block;
    content: '';
    position: absolute;
    top: 10px;
    left: -30px;
    height: 100%;
    width: 10px;
}
.StepProgress-item::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 5px;
    left: -35px;
    width: 12px;
    height: 12px;
    border: 2px solid #CCC;
    border-radius: 50%;
    background-color: #FFF;
}
.StepProgress-item.is-done::before {
    border-left: 2px solid rgba(21, 100, 153, 1);
}
.StepProgress-item.is-done::after {
    font-size: 10px;
    color: #FFF;
    text-align: center;
    border: 2px solid rgba(21, 100, 153, 1);
    background-color: rgba(21, 100, 153, 1);
}
.StepProgress strong {
    display: block;
}
</style>
